
export const selector = {
    namespaced: true,
    state: () => ({
        new: {},
        my: {},
        error: {
            new: {},
            my: {},
        },
        currentOfficeId: false
        // active : false,
        // data:{
        //     new: [],
        //     cancel:[],
        //     errors:[]
        // }
    }),

    mutations: {
        setCurrentOfficeId(state, id) {
            state.currentOfficeId = id
        },
        setError(state, data) {
            let type = data.isMy ? 'my' : 'new'

            state.error[type][data.sKey] = data['typeError']
        },
        deleteError(state, data) {
            let type = data.isMy ? 'my' : 'new'
            delete state.error[type][data.sKey]
        },
        resetErrors(state) {
            // сброс ошибок в других местах new
            var sizeNew = Object.keys(state.error.new).length;
            if (sizeNew) {
                for (var keyN in state.error.new) {
                    delete state.error.new[keyN]
                }
            }
            // сброс ошибок в других местах my
            var sizeMy = Object.keys(state.error.my).length;
            if (sizeMy) {
                for (var keyM in state.error.my) {
                    delete state.error.my[keyM]
                }
            }
        },
        selectNewCellCabinetLoad(state, data) {
            state.new = data
        },
        selectNewCellCabinet(state, data) {
            if (data.select) {
                state.new[data.officeId + ':' + data.cabinetId + ':' + data.hour + ':' + data.minute] = data
            } else {
                delete state.new[data.officeId + ':' + data.cabinetId + ':' + data.hour + ':' + data.minute]
            }
        },
        resetNewCellCabinet(state) {
            for (var index in state.new) {
                delete state.new[index]
            }
            // сброс ошибок в других местах new
            var size = Object.keys(state.error.new).length;
            if (size) {
                for (var key in state.error.new) {
                    delete state.error.new[key]
                }
            }
        },
        selectMyCellCabinet(state, data) {
            if (data.select) {
                state.my[data.officeId + ':' + data.cabinetId + ':' + data.hour + ':' + data.minute] = data
            } else {
                delete state.my[data.officeId + ':' + data.cabinetId + ':' + data.hour + ':' + data.minute]
            }
        },
        resetMyCellCabinet(state) {
            for (var index in state.my) {
                delete state.my[index]
            }
            // сброс ошибок в других местах my
            var size = Object.keys(state.error.my).length;
            if (size) {
                for (var key in state.error.my) {
                    delete state.error.my[key]
                }
            }

        },
    },
    actions: {
        selectNewCellCabinetLoad({commit}, data){
            commit("selectNewCellCabinetLoad", data);
        },
        setSelect({commit,state}, data) {
            // console.log(data)
            // отмена всех выделений, если кликнули на другом офисе
            if(state.currentOfficeId && data.officeId != state.currentOfficeId){
                commit("resetNewCellCabinet");
                commit("resetMyCellCabinet")
                commit("resetErrors")
            }
            commit("setCurrentOfficeId", data.officeId);
            if (data.mode === 'my') {
                commit("resetNewCellCabinet");
                commit("selectMyCellCabinet", data);
            } else {
                commit("resetMyCellCabinet");
                commit("selectNewCellCabinet", data);
            }

        },
        resetSelector({commit}) {
            commit("resetNewCellCabinet");
            commit("resetMyCellCabinet")
            commit("resetErrors")
        },
        setError({commit}, data) {
            commit("setError", data);
        },
        deleteError({commit}, data) {
            commit("deleteError", data);

        },
        // calculate({commit}, data){
        //     commit("setError",data);
        // }
    }
};